<template>
  <Modal :open="open" :close="close">
    <div class="px-10 py-5 w-[600px]">
      <h2 class="block font-bold text-center text-blueGray-600 mb-2">
        Please select the region
      </h2>
      <div class="flex justify-between mt-4">
        <div
          v-for="(item, i) in options.filter(
            (item) => item.value !== getRegion
          )"
          :key="i"
          @click="handleSelect(item)"
        >
          <div
            class="flex items-center justify-center w-[250px] items-center p-4 rounded cursor-pointer ease-linear transition-all duration-150"
            :class="
              selectedOptions.includes(item.value)
                ? 'bg-[#6b6ca9] text-white'
                : 'bg-gray-200 hover:bg-gray-100 hover:text-black'
            "
            v-if="getRegion !== item.value"
          >
            <p>{{ item.name }}</p>

            <IconSync
              class="ml-1 animate-spin"
              v-if="getSyncDataFetchLoading[item.value]"
            />
            <span v-else class="ml-1">{{ item.flag }}</span>
          </div>
        </div>
      </div>
      <div v-for="(item, i) in regionList" :key="i">
        <div
          class="mt-4 p-4 mb-4 bg-gray-200 rounded"
          v-if="
            selectedOptions.includes(item.value) &&
            instanceChecked[item.value] &&
            getSyncInstanceInfo[item.value].find(
              (item) => item.instance_name === componentId + '|' + instanceName
            )
          "
        >
          <div class="flex items-center justify-between">
            <div>
              <p class="text-xs mb-1">
                Already exist in {{ item.value.toUpperCase() }}
              </p>
              <p class="text-xs">Do you want to overwrite the exist one?</p>
            </div>
            <div class="flex text-sm items-center justify-end">
              <p class="mr-2">No</p>
              <ToggleBtn
                :status="shouldUpdate[item.value]"
                @update:status="handleUpdateStatus($event, item.value)"
              />
              <p class="ml-2">Yes</p>
            </div>
          </div>
          <div class="mt-6" v-if="shouldUpdate[item.value] === 'no'">
            <p class="text-xs mb-2"></p>
            <input
              type="text"
              v-model="newNameList[item.value]"
              :placeholder="`Enter a new name for ${item.value.toUpperCase()}`"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
            <p
              v-if="
                this.getSyncInstanceInfo[item.value].find(
                  (instance) =>
                    instance.instance_name.split('|')[1] ===
                    this.newNameList[item.value]
                )
              "
              class="text-xs text-red-500 mt-2"
            >
              Name already exist!
            </p>
            <p
              class="text-xs text-red-500 mt-2"
              v-if="newNameList[item.value].includes(' ')"
            >
              Please use '_' instead of space
            </p>
          </div>
        </div>
      </div>

      <div class="flex justify-between mt-6">
        <button
          @click="close"
          class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        >
          Cancel
        </button>
        <button
          :disabled="shouldDisableConfirm"
          @click="handleConfirm"
          :class="
            shouldDisableConfirm
              ? 'bg-gray-300 active:bg-gray-200'
              : 'bg-emerald-500 active:bg-emerald-600'
          "
          class="text-white flex font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
        >
          Confirm
          <IconSync class="ml-1 animate-spin" v-if="getSyncLoading" />
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import Modal from "@/components/Shared/Modal/Base";
import IconSync from "@/assets/icons/IconSync";
import ToggleBtn from "@/components/Shared/Input/ToggleBtn";

export default {
  name: "InstanceSyncModal",
  components: {
    Modal,
    IconSync,
    ToggleBtn
  },
  data() {
    return {
      instanceChecked: { au: false, nz: false, uk: false },
      loading: 0,
      errors: [],
      shouldUpdate: { au: "yes", nz: "yes", uk: "yes" },
      newNameList: { au: "", nz: "", uk: "" },
      currentStep: 1,
      selectedOptions: [],
      options: [
        { name: "Australia ", value: "au", flag: "🇦🇺" },
        { name: "New Zealand ", value: "nz", flag: "🇳🇿" },
        { name: "United Kingdom ", value: "uk", flag: "🇬🇧" }
      ]
    };
  },
  props: {
    close: {
      type: Function,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    },
    componentId: {
      type: String,
      required: true
    },
    instanceName: {
      type: [String, null],
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    shouldDisableConfirm() {
      let isValueEmpty;
      this.selectedOptions.every((region) => {
        if (this.shouldUpdate[region] === "no") {
          if (this.newNameList[region]) {
            isValueEmpty = false;
          } else {
            isValueEmpty = true;
            return;
          }
        } else {
          isValueEmpty = false;
        }
      });
      if (!this.selectedOptions.length || isValueEmpty) {
        return true;
      } else {
        return false;
      }
    },
    regionList() {
      return this.selectedOptions.map((region) => {
        return this.options.find((item) => item.value === region);
      });
    },
    ...mapGetters([
      "getRegion",
      "getSyncInstanceInfo",
      "getSyncDataFetchLoading",
      "getSyncLoading",
      "currentUser"
    ])
  },
  methods: {
    handleUpdateStatus(val, region) {
      this.shouldUpdate[region] = val;
    },
    handleConfirm() {
      if (this.type === "component") {
        this.$store
          .dispatch(Actions.SYNC_COMPONENT_INSTANCE, {
            oldName: `${this.componentId}|${this.instanceName}`,
            shouldUpdate: this.shouldUpdate,
            selectedOptions: this.selectedOptions,
            newNameList: this.newNameList,
            formData: this.formData,
            user: this.currentUser.email
          })
          .then(() => {
            this.close();
          });
      } else {
        this.$store
          .dispatch(Actions.SYNC_BLOG_INSTANCE, {
            oldName: `${this.componentId}|${this.instanceName}`,
            shouldUpdate: this.shouldUpdate,
            selectedOptions: this.selectedOptions,
            newNameList: this.newNameList,
            formData: this.formData,
            componentId: this.componentId,
            user: this.currentUser.email
          })
          .then(() => {
            this.close();
          });
      }
    },
    handleSelect(item) {
      if (!this.selectedOptions.includes(item.value)) {
        if (!this.instanceChecked[item.value]) {
          this.$store
            .dispatch(Actions.FETCH_SYNC_INSTANCE_INFO, {
              region: item.value,
              componentId: this.componentId
            })
            .then(() => {
              this.selectedOptions.push(item.value);
            })
            .then(() => {
              this.instanceChecked[item.value] = true;
            });
        } else {
          this.selectedOptions.push(item.value);
        }
      } else {
        this.selectedOptions = this.selectedOptions.filter(
          (i) => i !== item.value
        );
      }
    }
  }
};
</script>
